<template>
  <b-form-group
    label="Фильтр"
    label-cols-sm="3"
    label-align-sm="right"
    label-size="sm"
    label-for="filterInput"
    label-class="mb-0 search-filter__custom-label"
    class="mb-0 d-flex align-items-center full-width search-filter"
  >
    <b-input-group size="sm">
      <b-form-input
        id="filterInput"
        v-model="searchText"
        type="search"
        @input="onInput"
        placeholder="Поиск"
      ></b-form-input>
      <b-input-group-append>
        <b-button
          :disabled="!searchText"
          @click="clearFilter"
        >Очистить</b-button>
      </b-input-group-append>
    </b-input-group>
  </b-form-group>
</template>

<script>

import { BButton, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend } from 'bootstrap-vue'
import { ref, watch } from 'vue'

export default {
  name: 'SearchFilter',
  components: {
    BFormGroup, BButton, BInputGroup, BInputGroupAppend, BFormInput
  },
  props: {
    inputText: [String, null]
  },
  emits: ['input'],
  setup(props, { emit }) {
    const searchText = ref(null)

    const clearFilter = () => {
      searchText.value = null
      emitInputEvent()
    }
    const onInput = event => {
      searchText.value = event
      emitInputEvent()
    }
    const emitInputEvent = () => emit('input', searchText.value)

    watch(() => props.inputText, () => {
      searchText.value = props.inputText
      emitInputEvent()
    })

    return {
      searchText,

      clearFilter,
      onInput
    }
  }
}
</script>

<style lang='scss'>

.search-filter {
  &__custom-label {
    flex: 0 !important;
  }

  .col {
    padding-right: 0 !important;
  }
}

</style>
